<template>
  <div class="mr-3 mt-3">
    <v-dialog width="450" v-model="searchModal">
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-2">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-magnify</v-icon>
              <span class="modal-title-text mr-2">جستجو</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-5">
          <v-row>
            <v-col cols="12">
              <v-text-field
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle-outline"
                label="تشخیص"
                v-model="searchDiagnosis"
                autocomplete="off"
                prepend-inner-icon="mdi-text mdi-18px"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="mt-n4">
              <v-autocomplete
                :items="allCitysForOther"
                no-data-text="اطلاعاتی وجود ندارد"
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle-outline"
                item-text="title"
                item-value="id"
                label="شهر"
                v-model="searchCityId"
                autocomplete="off"
                prepend-inner-icon="mdi-home-city mdi-18px"
                style="font-size: 11px !important"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" class="mt-n4">
              <v-autocomplete
                :items="allResultBaseDataWithPatient"
                no-data-text="اطلاعاتی وجود ندارد"
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle-outline"
                item-text="title"
                item-value="id"
                label="نتیجه"
                v-model="searchResultId"
                autocomplete="off"
                prepend-inner-icon="mdi-ambulance mdi-18px"
                style="font-size: 11px !important"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" class="mt-n4">
              <v-autocomplete
                :items="allTagsForOther"
                no-data-text="اطلاعاتی وجود ندارد"
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle-outline"
                item-text="title"
                item-value="id"
                label="برچسب"
                v-model="searchTagId"
                autocomplete="off"
                prepend-inner-icon="mdi-tag mdi-18px"
                style="font-size: 11px !important"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" class="mt-n4">
              <v-text-field
                type="text"
                outlined
                id="user-moveFromStationTime"
                ref="moveFromStationTime"
                dense
                clearable
                autocomplete="off"
                @click:clear="clearDateTime('searchFromDate')"
                clear-icon="mdi-close-circle-outline"
                v-model="tempSearchFromDate"
                @focus="showSearchFromDate = true"
                @click="showSearchFromDate = true"
                label="از تاریخ"
                prepend-inner-icon="mdi-calendar-range mdi-18px"
              >
                <template slot="append">
                  <v-icon
                    @click="showSearchFromDate = true"
                    class="calender-background ml-n3 mt-n2"
                    color="white"
                  >
                    mdi-calendar-range mdi-18px
                  </v-icon>
                </template>
              </v-text-field>
              <date-picker
                :show="showSearchFromDate"
                simple
                v-model="searchFromDate"
                type="datetime"
                @open="onOpen"
                @change="dateTimeChange('searchFromDate')"
                :editable="true"
                format="YYYY-MM-DDTHH:mm:ss"
                display-format="HH:mm:ss jYYYY/jMM/jDD"
                custom-input="#moveFromStationTime-moveFromStationTime"
                @close="showSearchFromDate = false"
              />
            </v-col>
            <v-col cols="12" class="mt-n4">
              <v-text-field
                type="text"
                outlined
                id="user-arriveToLocationTime"
                ref="arriveToLocationTime"
                dense
                autocomplete="off"
                clearable
                @click:clear="clearDateTime('searchToDate')"
                clear-icon="mdi-close-circle-outline"
                v-model="tempSearchToDate"
                @focus="showSearchToDate = true"
                @click="showSearchToDate = true"
                label="تا تاریخ"
                prepend-inner-icon="mdi-calendar-range mdi-18px"
              >
                <template slot="append">
                  <v-icon
                    @click="showSearchToDate = true"
                    class="calender-background ml-n3 mt-n2"
                    color="white"
                  >
                    mdi-calendar-range mdi-18px
                  </v-icon>
                </template>
              </v-text-field>
              <date-picker
                :show="showSearchToDate"
                simple
                type="datetime"
                @open="onOpen"
                v-model="searchToDate"
                @change="dateTimeChange('searchToDate')"
                :editable="true"
                format="YYYY-MM-DDTHH:mm:ss"
                display-format="HH:mm:ss jYYYY/jMM/jDD"
                custom-input="#arriveToLocationTime-arriveToLocationTime"
                @close="showSearchToDate = false"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn
            color="darkColor"
            @click="search()"
            dark
            rounded
            class="normal-letter-spacing px-12"
          >
            جستجو
          </v-btn>
          <v-btn
            rounded
            color="darkColor"
            outlined
            @click="cancelSearch()"
            class="normal-letter-spacing px-10"
          >
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <l-map
      v-if="isMapReadyToShow"
      ref="modalmap"
      style="height: 92vh !important; z-index: 1"
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
      @ready="mapInvalidate()"
    >
      <l-tile-layer :url="mapTileUrl" :attribution="attribution"></l-tile-layer>
      <l-control position="topright">
        <v-btn
          icon
          small
          tile
          class="no-letter-space"
          @click="showSearchModal()"
          style="
            background-color: white;
            border: solid;
            border-width: 2px;
            border-radius: 5px;
            border-color: #c2bfba;
            padding: 15px;
          "
        >
          <v-icon>mdi-magnify mdi-18px</v-icon>
        </v-btn>
      </l-control>
      <l-control position="topleft">
        <div>
          <v-btn
            icon
            small
            tile
            class="no-letter-space mb-2 block"
            style="
              background-color: white;
              border: solid;
              border-width: 2px;
              border-radius: 5px;
              border-color: #c2bfba;
              width: 35px;
              aspect-ratio: 1;
              display: block;
            "
            @click="toggleHeatMapLayer"
          >
            <v-icon>mdi-layers-outline mdi-18px</v-icon>
          </v-btn>
          <v-btn
            @click="exportToExcel(headers, excelItems, 'text', 'amar_heat_map_lat_lngs')"
            icon
            small
            tile
            class="no-letter-space"
            style="
              background-color: white;
              border: solid;
              border-width: 2px;
              border-radius: 5px;
              border-color: #c2bfba;
              width: 35px;
              aspect-ratio: 1;
              display: block;
            "
          >
            <v-icon>mdi-file-excel mdi-18px</v-icon>
          </v-btn>
        </div>
      </l-control>
      <Vue2LeafletHeatmap
        v-if="isHeatMapLayer"
        :lat-lng="latlngs"
        :radius="10"
        :min-opacity="0.5"
        :max-zoom="18"
        :blur="8"
        :gradient="{ 0.4: 'green', 0.65: 'yellow', 1: 'red' }"
      ></Vue2LeafletHeatmap>
      <v-marker-cluster v-else :options="{ disableClusteringAtZoom: 17 }">
        <l-marker v-for="(latlng, index) in latlngs" :key="index" :lat-lng="latlng">
          <l-icon v-bind="missionLocationIcon"></l-icon>
        </l-marker>
      </v-marker-cluster>
    </l-map>
    <alert-component
      ref="snackRef"
      :snakTimeOut="snakTimeOut"
      :snackColor="snackColor"
      :snackText="snackText"
      :snakIcon="snakIcon"
    ></alert-component>
  </div>
</template>
<script>
  import { latLng } from 'leaflet';
  import 'leaflet/dist/leaflet.css';
  import { LMap, LTileLayer, LControl, LMarker, LIcon } from 'vue2-leaflet';
  import Vue2LeafletHeatmap from '@/components/Vue2LeafletHeatmap.vue';
  import AlertComponent from '@/components/AlertComponent.vue';
  import Vue2LeafletMarkercluster from 'vue2-leaflet-markercluster';
  import ExcelHelper from '@/Helpers/Excel.generator.helper';
  import snackBar from '@/Mixins/snackBar.js';
  import ShearedMixin from '@/Mixins/Shared.js';
  import ShearedHelper from '@/Helpers/Shared.js';
  import ReportMixin from '@/Mixins/Report/ReportMixin.js';
  import CityMixin from '@/Mixins/BaseInformation/CityMixin.js';
  import ResultBaseDataMixin from '@/Mixins/BaseInformation/ResultBaseDataMixin.js';
  import TagMixin from '@/Mixins/BaseInformation/TagMixin.js';
  import HeatMapReportHelper from '@/Helpers/Report/Amar/HeatMapReportHelper.js';
  import SharedMap from '@/Mixins/map';
  export default {
    name: 'amarHeatMapReport',
    title: 'گزارش مبتنی بر نقشه ',
    inject: ['load'],
    components: {
      AlertComponent,
      LMap,
      LTileLayer,
      Vue2LeafletHeatmap,
      LControl,
      LMarker,
      LIcon,
      'v-marker-cluster': Vue2LeafletMarkercluster,
    },
    mixins: [
      HeatMapReportHelper,
      ShearedMixin,
      ReportMixin,
      snackBar,
      ShearedHelper,
      ResultBaseDataMixin,
      CityMixin,
      TagMixin,
      ExcelHelper,
      SharedMap,
    ],
    created() {
      this.$root.$refs.AmarHeatMapReport = this;
    },
    mounted() {
      this.mounteLoding();
    },
    beforeDestroy() {},
    data() {
      return {
        latlngs: [],
        currentZoom: 12,
        currentCenter: latLng(30.2839, 57.0834),
        mapOptions: {
          zoomSnap: 0.5,
          scrollWheelZoom: true,
        },
      };
    },
    methods: {
      mounte: function () {
        this.setPreTimes();
        this.getAmarHeatMapReportFunction(
          this.searchFromDate,
          this.searchToDate,
          this.searchDiagnosis,
          this.searchResultId,
          this.searchTagId,
          this.searchCityId,
        );
        this.getAllResultBaseDatasWithPatientFunction();
        this.getListOfCitysForOther();
        this.getListOfTagsForOther();
        this.setMapBaseSystemSetting();
      },
      centerUpdate(center) {
        this.currentCenter = center;
      },
      zoomUpdate(zoom) {
        this.currentZoom = zoom;
      },
      mapInvalidate: function () {
        setTimeout(() => {
          this.$refs.modalmap.mapObject.invalidateSize();
        }, 100);
      },
    },
    computed: {
      missionLocationIcon: function () {
        return {
          iconSize: '[15,30]',
          iconAnchor: '[7.5,30]',
          iconUrl: require('@/assets/images/mission_point.svg'),
        };
      },
      excelItems: function () {
        return this.items.map(({ creationDate, ...rest }) => ({
          creationDate: this.getJalaliDate(creationDate),
          ...rest,
        }));
      },
    },
  };
</script>
<style>
  @import '~leaflet.markercluster/dist/MarkerCluster.css';
  @import '~leaflet.markercluster/dist/MarkerCluster.Default.css';
</style>
